<div class="text">
    
    <br>
    <br>

    <div style="padding-left:calc(50% - 200px)">
    <img style="padding-bottom: 10px; padding-left:40px" src="assets//landscape150.svg?x=1" />
    <h2>Welcome to Estate Maps</h2>
    </div>
    
    <br>
    <br>

    <h3>Helpdesk</h3>
    For questions or requests please contact the <a class="aip-primary-link" target="_blank" href="https://dxcportal.sharepoint.com/sites/applications/helpdesk/SitePages/Home.aspx">SPST App Support Helpdesk</a>
    <br/>When submitting a request the Program field should be set to "Estate Maps".

<br>
<br>
<br>

<a class='aip-primary-link guidance' (click)="this.showHelpDialog()">For guidance on who needs to maintain the data for each acccount see this Contribution Guidelines</a>

<br>
<br>
<br>

<h3>Useful Links</h3>

<a class="aip-primary-link" href="https://ocexternal.itcs.houston.dxc.technology/insightportal/home" target="_blank" rel="noopener noreferrer">DXC Insight Portal</a>
<br>
<a class="aip-primary-link" href="https://accessmanager.dxc.com/uam/default.aspx" target="_blank" rel="noopener noreferrer">User Access Management (UAM)</a>
<br>
<a class="aip-primary-link" href="https://dxc-servicelandscape.azurewebsites.net/" target="_blank" rel="noopener noreferrer">Powerpoint Export Assistant</a>
<br>
<a class="aip-primary-link" href="https://app.powerbi.com/groups/me/apps/a2530fdd-5444-4eb5-970d-a51f5f047ff1/reports/b735e04c-0129-4aad-848d-b98fbb963e2e/ReportSectionbb2bce716631738f7875" target="_blank" rel="noopener noreferrer">Enterprise Management System (EMS)</a>
<br>


</div>